export const selector = '.venture-three-column'

export default (
    el = null
) => {
    if (!el)
        return

    console.groupCollapsed('VentureThreeColumn')

    const filterPlacement = el.querySelector(
        'select[name="placement"]')

    const filterYear = el.querySelector(
        'select[name="placementYear"]')

    const venturesGrid = el.querySelector(
        '#venture-three-column-items-wrapper')

    const spinner = el.querySelector(
        '.venture-three-column-spinner')

    const { paginationBase } = el.dataset

    const filterParams = {
        placement: '0',
        placementYear: '0',
        paginationBase
    }

    if (!filterPlacement
        && !filterYear
        && !venturesGrid)
        return

    const spinnerToggle = (show) => {
        if (!spinner)
            return

        spinner.classList[show
            ? 'remove'
            : 'add']('venture-three-column-spinner-hide')
    }

    const updateResults = async (e) => {
        const target = e.target

        if (!target
            && !target.name
            && !target.value)
            return

        spinnerToggle(true)

        const name = target.name
        const value = target.value
            && target.value !== '0'
                ? target.value
                : ''

        filterParams[name] = value

        await window.fetch('/wp/wp-admin/admin-ajax.php?action=filter_venues_grid', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(filterParams),
        }).then(response => {
            return response.text()
        }).then(response => {
            if (response){
                venturesGrid.innerHTML = response
            }

            spinnerToggle(false)
        }).catch(error => {
            console.error(error)
        })
    }

    filterPlacement
        .addEventListener('change', updateResults)

    filterYear
        .addEventListener('change', updateResults)

    if (import.meta.hot)
        import.meta.hot
            .on('vite:beforeUpdate', () => {
                if (filterPlacement)
                    filterPlacement
                        .removeEventListener('change',
                            updateResults)

                if (filterYear)
                    filterYear
                        .removeEventListener('change',
                            updateResults)
            })

    // Log els
    console.log(el)

    console.groupEnd()

    return el
}
